<template>
    <li class="pt-12 relative pl-6 md:pl-12 flex justify-content-between items-center">

        <span class="absolute flex justify-center items-center w-8 h-8 rounded-full shadow-lg bg-white text-yellow-400 border-2 border-yellow-400"
              style="top: 50%; left: -17px">
            <icon-ticket-outline class="w-5 h-5"></icon-ticket-outline>
        </span>

        <div class="flex justify-between items-start flex-grow-1 relative">
            <div class="">
                <h4 class="font-medium">{{ activity.activity }}</h4>
                <p class="text-gray-500 font-normal text-sm">{{ activity.notes }}</p>
                <div class="p-1">
                    <button type="button"
                            class="inline-flex items-center mr-1 -ml-1.5 px-1.5 py-0.5 border border-transparent text-xs leading-4 font-medium rounded text-indigo-600 bg-indigo-100 hover:text-indigo-800 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-300"
                            @click.prevent="sendEmailNotification">
                        Email
                    </button>
                    <button type="button"
                            class="inline-flex items-center mr-1 px-1.5 py-0.5 border border-transparent text-xs leading-4 font-medium rounded text-indigo-600 bg-indigo-100 hover:text-indigo-800 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-300"
                            @click.prevent="sendSmsNotification">
                        Sms
                    </button>
                </div>
            </div>
            <div class="pl-4 text-gray-400 text-xs min-w-100 leading-tight">
                <div class="text-right whitespace-nowrap">{{ activity.created_at | date }}</div>
                <div class="text-right"><span>{{ activity.created_at | timeonly }}</span></div>
            </div>
        </div>
    </li>
</template>

<script>
import CommonProps from "../../../mixins/activity-common-mixin";

export default {

    mixins: [CommonProps],

    data () {
        return {
            maintenance_request: this.activity.source,
            showNotificationTypeSelector: false
        };
    },

    methods: {
        setNotificationTypeSelector () {
            let self = this;
            self.showNotificationTypeSelector = true;
            setTimeout(function () {
                self.showNotificationTypeSelector = false;
            }, 4000);
        },
    }
};

</script>
